import { setContext } from "apollo-link-context";

export const versioningMiddleware = setContext((operation, previousContext) => {
  previousContext.headers = {
    ...previousContext?.headers,
    "x-version": process.env.VUE_APP_VERSION
  };
  return previousContext;
});
